import Layout from '@/components/layout/index.vue'

export default {
  path: 'supplier-develop',
  name: 'SupplierDevelop',
  meta: {},
  component: Layout,
  redirect: { name: 'SupplierDevelop.Import' },
  children: [
    {
      path: 'import',
      name: 'SupplierDevelop.Import',
      meta: {},
      component: () => import(/* webpackChunkName: "supplier-develop" */ '@/views/purchaser/supplier-develop/import/index.ts')
    },
    {
      path: 'import/add',
      name: 'SupplierDevelop.Import.Add',
      meta: { title: 'common.add', dep: 'SupplierDevelop.Import' },
      component: () => import(/* webpackChunkName: "supplier-develop" */ '@/views/purchaser/supplier-develop/import/add.ts')
    },
    {
      path: 'import/modify/:id',
      name: 'SupplierDevelop.Import.Modify',
      meta: { title: 'common.modify', dep: 'SupplierDevelop.Import' },
      component: () => import(/* webpackChunkName: "supplier-develop" */ '@/views/purchaser/supplier-develop/import/modify.ts')
    },
    {
      path: 'progress',
      name: 'SupplierDevelop.Progress',
      meta: {},
      component: () => import(/* webpackChunkName: "supplier-develop" */ '@/views/purchaser/supplier-develop/progress/index.ts')
    }
  ]
}
